import License from '../Licenses/Model'

export default class Device {
  id: number
  serial: string
  model: string
  manufacturer: string
  brand: string
  sdk: string
  enabled: boolean
  disabled: boolean
  terminalnumero: string
  blocked: boolean
  disabled_at: Date | null = null
  blocked_at: Date | null = null
  license: License | null = null

  constructor(values) {
    Object.assign(this, values)
    if (values.disabled_at) {
      this.disabled_at = new Date(values.disabled_at)
    }
    if (values.blocked_at) {
      this.disabled_at = new Date(values.blocked_at)
    }
    if (values.license) {
      this.license = new License(values.license)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Devices/Model.ts